import { EnvironmentProviders, inject, Provider, provideAppInitializer } from '@angular/core';
import { AuthService } from './auth.service';
import { createOktaAuthClient } from './create-okta-auth-client';
import { OKTA_AUTH } from './okta-auth.token';

/**
 * Registers Okta auth providers and bootstraps session state before the app renders.
 */
export function provideAuth(): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: OKTA_AUTH,
      useFactory: () => createOktaAuthClient(),
    },
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      return auth.bootstrap();
    }),
  ];
}
